import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const getListTestMasterApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}test-master${params.dropDownList}`,
        method: "get",
        params: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })
    return response.data
}

export default getListTestMasterApi